import React, { useState, useEffect } from 'react';
import moment from "moment";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import {useAuth} from '../../Common/Configurations/AuthContext';
import DefaultData from '../../CompanyData/DefaultData';
const HotelGuests = () => {
    const { state } = useLocation();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [checkIn, setCheckIn] = useState(new Date());
    const [checkOut, setCheckOut] = useState(new Date());
    const [nights, setNights] = useState(1);
    const [searchQuery, setSearchQuery] = useState({});
    const [saveHotel, setSaveHotel] = useState({});
    const [hotelRoom, setHotelRoom] = useState({});
    const [guestRooms, setGuestRooms] = useState([]);
    const [price, setPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [email, setEmail] = useState(DefaultData?.DEFAULTCOMPANYEMAIL);
    const [mobile, setMobile] = useState(DefaultData?.DEFAULTCOMPANYPHONENUMBER);
    const [proceed, setProceed] = useState(true);
    const handleAdultChange = (roomindex, fieldindex, field, value) => {
        const updatedRooms = [...guestRooms];
        if (field == "title") {
            var gender = "MALE";
            if (value === "Mr") {
                gender = "MALE";
            }
            else if (value === "Mrs") {
                gender = "FEMALE";
            }
            else if (value === "Ms") {
                gender = "FEMALE";
            }
            else if (value === "Master") {
                gender = "MALE";
            }
            updatedRooms[roomindex].adultsFields[fieldindex]['gender'] = gender;
        }
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${'adults'}-${field}-${roomindex}-${fieldindex}`]; // Remove error when input is fixed
            return newErrors;
        });
        updatedRooms[roomindex].adultsFields[fieldindex][field] = value;
        setGuestRooms(updatedRooms);
    };
    const handleKidChange = (roomindex, fieldindex, field, value) => {
        const updatedRooms = [...guestRooms];
        if (field == "title") {
            var gender = "MALE";
            if (value === "Mr") {
                gender = "MALE";
            }
            else if (value === "Mrs") {
                gender = "FEMALE";
            }
            else if (value === "Ms") {
                gender = "FEMALE";
            }
            else if (value === "Master") {
                gender = "MALE";
            }
            updatedRooms[roomindex].kidsFields[fieldindex]['gender'] = gender;
        }
        updatedRooms[roomindex].kidsFields[fieldindex][field] = value;
        setGuestRooms(updatedRooms);
    };
    function getPaymentInfo() {
        const myobject = [{
            amount: price
        }];
        return myobject;
    }
    function getDeliveryinfo() {
        const emails = [email];
        const contacts = [mobile];
        const code = ["+91"];
        const deliveryinfo = {
            emails: emails,
            contacts: contacts,
            code: code
        };
        return deliveryinfo;
    }
    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }
    const handleMobileChange = (e) => {
        setMobile(e.target.value)
    }
    const handleHotelSearch = (e) => {
        navigate('/hotelslist/', { state: { searchQuery } });
    }
    const handleBooking = (e) => {
        e.preventDefault();
        if (validateFields(guestRooms)) {
            const hotelBookingRequest = {
                commonHotelSearchRequest: searchQuery,
                commonHotelDetails: saveHotel,
                commonHotelAllRooms: hotelRoom,
                requestedBy: "AGENT",
                supplierBookingId: "",
                paymentInfos: getPaymentInfo(),
                hotelGuestInfos: guestRooms,
                deliveryInfo: getDeliveryinfo(),
                email: email,
                mobile: mobile,
                userId: user?.id,
                branchId: user?.bid,
                transactionNo: "",
                paymentStatus: "",
                bookingType: hotelRoom.bookingType,
                cancellationDate: hotelRoom.cancellationDate,
                supplierCancellationDate: hotelRoom.supplierCancellationDate,
                supplierId: saveHotel.supplierId,
                gatewayAmount: 0,
                walletAmount: 0,
                creditAmount: 0,
                markup: 0,
                customerPrice: 0,
                paymentGatewayNo: "",
                paymentGateway: "RAZORPAY"
            }
            ReviewRoom(hotelBookingRequest)
        }
    };
    const validateFields = (tempguestRooms) => {
        const newErrors = {};
        tempguestRooms.forEach((data, index) => {
            data.adultsFields.forEach((adult, i) => {
                if (!adult.firstName) {
                    newErrors[`adults-firstName-${index}-${i}`] = 'First Name is required';
                }
                if (!adult.lastName) {
                    newErrors[`adults-lastName-${index}-${i}`] = 'Last Name is required';
                }
                if (!adult.panCard) {
                    newErrors[`adults-panCard-${index}-${i}`] = 'Pan Card is required';
                }
            });

            data.kidsFields.forEach((kid, i) => {
                if (!kid.firstName) {
                    newErrors[`kids-firstName-${index}-${i}`] = 'First Name is required';
                }
                if (!kid.lastName) {
                    newErrors[`kids-lastName-${index}-${i}`] = 'Last Name is required';
                }
            });
        });
        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const validate = () => {
        let temp = {};
        temp.email = email === "" ? false : true;
        temp.mobile = mobile === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const ReviewRoom = async (hotelBookingRequest) => {
        if (validate()) {
            setPageLoading(true);
            var result = await apiService.post(config.HOTELREVIEW, hotelBookingRequest);
            console.log(result);
            if (result.succeeded) {
                var responseData = result.data;
                hotelBookingRequest.supplierBookingId = responseData?.supplierBookingId;
                hotelBookingRequest.hotelBookingId = responseData?.hotelBookingId;
                hotelBookingRequest.bookingNo = responseData.bookingNo;
                setPageLoading(false);
                navigate('/hotel/review/', { state: { responseData } });
            }
            else {
                setPageLoading(false);
                setProceed(false);
                alert(responseData.message)
            }
        }
    };
    useEffect(() => {
        if (state === null) {
            navigate('/search/hotels')
        }
        else if (state.requestData === null) {
            navigate('/search/hotels')
        }
        else if (state.requestData.commonHotelSearchRequest === null) {
            navigate('/search/hotels')
        }
        else {
            setPageLoading(false);
            setSearchQuery(state.requestData.commonHotelSearchRequest)
            setSaveHotel(state.requestData.commonHotelDetails)
            setHotelRoom(state.requestData.commonHotelAllRooms)
            setGuestRooms(state.requestData.commonHotelSearchRequest.hotelRooms)
            setCheckIn(state.requestData.commonHotelSearchRequest.checkInDate)
            setCheckOut(state.requestData.commonHotelSearchRequest.checkOutDate)

            setPrice(state.requestData.commonHotelAllRooms.price);
            setTotalPrice(state.requestData.commonHotelAllRooms.totalprice)
            const cinDate = new Date(state.requestData.commonHotelSearchRequest.checkInDate);
            const coutDate = new Date(state.requestData.commonHotelSearchRequest.checkOutDate);
            const diffTime = Math.abs(coutDate.getTime() - cinDate.getTime());
            const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setNights(nights);
        }
    }, []);
    return (
        <div className="container-fluid mt-2">
            <div className="row align-items-start">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="div-title d-flex align-items-center mb-3">
                        <h4>Guests Details</h4>
                    </div>
                    <div className="row align-items-start">
                        <div className="col-xl-8 col-lg-8 col-md-12">
                            {guestRooms.length > 0 && guestRooms.map((room, index) =>
                                <div className="card mb-3 p-4" key={index}>
                                    <h6>Room {index + 1}</h6>
                                    {room.adultsFields.length > 0 && room.adultsFields.map((ra, adultIndex) => (
                                        <>
                                            <div className="card-header">
                                                <h6>Adult {adultIndex + 1}</h6>
                                            </div>
                                            <div className="card-body" key={adultIndex}>
                                                <div className="row">
                                                    <div className="col-xl-2 col-lg-6 col-md-6">
                                                        <label className="form-label">Title</label>
                                                        <select className="form-select" name="title" required value={room.adultsFields[adultIndex].title} onChange={(e) => handleAdultChange(index, adultIndex, 'title', e.target.value)}>
                                                            <option value="Mr">Mr</option>
                                                            <option value="Mrs">Mrs</option>
                                                            <option value="Miss">Miss</option>
                                                            <option value="Master">Master</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">First Name</label>
                                                            <input type="text" className="form-control" name="firstName" placeholder="First Name" value={room.adultsFields[adultIndex].firstName} onChange={(e) => handleAdultChange(index, adultIndex, 'firstName', e.target.value)} autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true" />
                                                            {errors[`adults-firstName-${index}-${adultIndex}`] && (
                                                                <span style={{ color: 'red' }}>{errors[`adults-firstName-${index}-${adultIndex}`]}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">Last Name</label>
                                                            <input type="text" className="form-control" name="lastName" placeholder="Last Name" value={room.adultsFields[adultIndex].lastName} onChange={(e) => handleAdultChange(index, adultIndex, 'lastName', e.target.value)} autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                                            {errors[`adults-lastName-${index}-${adultIndex}`] && (
                                                                <span style={{ color: 'red' }}>{errors[`adults-lastName-${index}-${adultIndex}`]}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-2 col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">Pan Card</label>
                                                            <input type="text" className="form-control" name="lastName" placeholder="ABCDE1234F" value={room.adultsFields[adultIndex].panCard} onChange={(e) => handleAdultChange(index, adultIndex, 'panCard', e.target.value)} autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                                            {errors[`adults-panCard-${index}-${adultIndex}`] && (
                                                                <span style={{ color: 'red' }}>{errors[`adults-panCard-${index}-${adultIndex}`]}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                    {room.kidsFields.length > 0 && room.kidsFields.map((_, kidIndex) => (
                                        <>
                                            <div className="card-header">
                                                <h6>Kid {kidIndex + 1}</h6>
                                            </div>
                                            <div className="card-body" key={kidIndex}>
                                                <div className="row">
                                                    <div className="col-sm-2">
                                                        <label className="form-label">Title</label>
                                                        <select className="form-control" name="title" required value={room.kidsFields[kidIndex].title} onChange={(e) => handleKidChange(index, kidIndex, 'title', e.target.value)}>
                                                            <option value="Miss">Miss</option>
                                                            <option value="Master">Master</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">First Name</label>
                                                            <input type="text" className="form-control" placeholder="First Name" value={room.kidsFields[kidIndex].firstName} onChange={(e) => handleKidChange(index, kidIndex, 'firstName', e.target.value)} autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                                            {errors[`kids-firstName-${index}-${kidIndex}`] && (
                                                                <span style={{ color: 'red' }}>{errors[`kids-firstName-${index}-${kidIndex}`]}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                                        <div className="form-group">
                                                            <label className="form-label">Last Name</label>
                                                            <input type="text" className="form-control" name="lastName" placeholder="Last Name" value={room.kidsFields[kidIndex].lastName} onChange={(e) => handleKidChange(index, kidIndex, 'lastName', e.target.value)} autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                                            {errors[`kids-lastName-${index}-${kidIndex}`] && (
                                                                <span style={{ color: 'red' }}>{errors[`kids-lastName-${index}-${kidIndex}`]}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))}
                                </div>
                            )}
                            <div className="card mb-3 p-4">
                                <div className="row align-items-stat">
                                    <div className="col-xl-12 col-lg-12 col-md-12 mb-2">
                                        <h5>Personal Information</h5>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">Email Address</label>
                                            <input type="text" value={email} name="email" onChange={handleEmailChange} className="form-control" placeholder="Email Here" autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                            {errors.email === false ? (<div className="validationerror">Please enter email </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <label className="form-label">Mobile number</label>
                                            <input type="text" value={mobile} maxLength={10} name="mobile" onChange={handleMobileChange} className="form-control" placeholder="Mobile Number" autoComplete="off" autoCorrect="off" spellCheck="false" data-lpignore="true"/>
                                            {errors.mobile === false ? (<div className="validationerror">Please enter mobile </div>) : ('')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="side-block card rounded-2 p-3">
                                <div className="bott-block d-block mb-3">
                                    <h5 className="fw-semibold fs-6">Booking Summary</h5>
                                    <ul className="list-group list-group-borderless">
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Booking Type</span>
                                            <span className="fw-semibold">{hotelRoom.bookingType === "NONREFUNDABLE" ? <span className="badge bg-danger me-2">NON REFUNDABLE</span> : <span className="badge bg-success me-2">{hotelRoom.bookingType}</span>}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Hotel Name</span>
                                            <span className="fw-semibold">{saveHotel.hotelName}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Address</span>
                                            <span className="fw-semibold">{saveHotel.address},<br></br>{saveHotel.cityName},{saveHotel.countryName},{saveHotel.postalCode}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Check-In</span>
                                            <span className="fw-semibold">{moment(checkIn).format('DD-MM-YYYY')}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Check-Out</span>
                                            <span className="fw-semibold">{moment(checkOut).format('DD-MM-YYYY')}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Nights</span>
                                            <span className="fw-semibold">{nights}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Total Guests</span>
                                            <span className="fw-semibold">{searchQuery?.totalGuests}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Total Rooms</span>
                                            <span className="fw-semibold">{searchQuery?.totalRooms}</span>
                                        </li>
                                        {hotelRoom?.requestedHotels?.length > 0 && hotelRoom.requestedHotels.map((rh, index) =>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span className="fw-medium mb-0">Room {index + 1} : </span>
                                                <span className="fw-semibold">{rh.roomType}</span>
                                            </li>
                                        )}
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium mb-0">Net Price</span>
                                            <span className="fw-semibold">INR {Math.round(hotelRoom.price)}</span>
                                        </li>
                                        {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="fw-medium mb-0">Taxes & Fees</span>
                                                            <span className="fw-semibold">INR {Math.round(hotelRoom.taxAndFee)}</span>
                                                        </li> */}
                                        {hotelRoom.tcsAmount > 0 ?
                                            <li className="list-group-item d-flex justify-content-between align-items-center">
                                                <span className="fw-medium mb-0">TCS</span>
                                                <span className="fw-semibold">INR {Math.round(hotelRoom.tcsAmount)}</span>
                                            </li>
                                            : ""}
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span className="fw-medium text-success mb-0">Total Price</span>
                                            <span className="fw-semibold text-success">INR {Math.round(hotelRoom.totalPrice)}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="bott-block">
                                    {pageLoading === false ?
                                        <>
                                            <button className="btn fw-medium btn-success full-width me-2" type="button" onClick={handleBooking}>Process To Payment</button>
                                            <button className="btn fw-medium btn-danger full-width me-2" type="button" onClick={handleHotelSearch}>Back to hotel search</button>
                                        </>
                                        :
                                        <>
                                            <button className="btn fw-medium btn-success full-width me-2" type="button" disabled>Loading...</button>
                                            <button className="btn fw-medium btn-danger full-width me-2" type="button" onClick={handleHotelSearch}>Back to hotel search</button>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelGuests;
